import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
} from "@mui/material";
import { PrimaryButton, SectionLabel } from "components";
import DropdownDSPSettings from "./DropdownDSPSettings";

const ModalTransactionDsp = ({
  open,
  onClose,
  optionDsp,
  handleSelectDspTransaction,
}) => {
  return (
    <Dialog fullWidth open={open} onClose={onClose} maxWidth="md">
      <DialogTitle>
        <SectionLabel
          title="View Transaction DSP Publisher"
          subTitle="Feature to set view DSP Publisher"
        />
      </DialogTitle>
      <DialogContent dividers>
        <Stack>
          {optionDsp?.map((item, index) => (
            <DropdownDSPSettings
              key={index}
              item={item}
              onChange={e =>
                handleSelectDspTransaction(e?.target?.checked, index)
              }
            />
          ))}
        </Stack>
      </DialogContent>
      <DialogActions>
        <PrimaryButton label="Close" onClick={onClose} />
      </DialogActions>
    </Dialog>
  );
};

export default ModalTransactionDsp;
